// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Popup/Popup.css */

.popup-overlay {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: calc(100vh - 40px);
    overflow-y: auto;
}

.popup-container {
    position: fixed;
    top: 92px;
    right: 18px;
    z-index: 1200;
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: min(360px, calc(100vw - 28px));
    max-height: 75vh;
    overflow-y: auto;
    padding: 2px;
    scrollbar-width: thin;
    scrollbar-color: rgba(54, 76, 99, 0.35) transparent;
}

.popup-message {
    position: relative;
    isolation: isolate;
    overflow: hidden;
    border: 1px solid rgba(54, 76, 99, 0.12);
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0 18px 38px rgba(31, 46, 64, 0.18);
    padding: 13px 42px 13px 14px;
    cursor: pointer;
    animation: slideIn 0.22s ease-out;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    text-align: left;
    font-family: inherit;
}

.popup-message:hover {
    transform: translateY(-2px) translateX(-2px);
    box-shadow: 0 22px 44px rgba(31, 46, 64, 0.22);
}

.popup-message.high,
.popup-message.red {
    border-color: #ffb1b1;
    background: linear-gradient(135deg, #fffafa 0%, #ffe7e7 100%);
    color: #6d2020;
}

.popup-message.medium,
.popup-message.orange {
    border-color: #ffd49b;
    background: linear-gradient(135deg, #fffaf0 0%, #ffefd7 100%);
    color: #70430f;
}

.popup-message.low,
.popup-message.green {
    border-color: #afe0bf;
    background: linear-gradient(135deg, #f7fff9 0%, #e3f8ea 100%);
    color: #1f5b3e;
}

.popup-message.past,
.popup-message.grey {
    border-color: #d4dbe3;
    background: linear-gradient(135deg, #fbfcfd 0%, #edf0f3 100%);
    color: #52657a;
}

.popup-message::before {
    content: '';
    position: absolute;
    inset: 0 auto 0 0;
    width: 5px;
    background: #2f9e75;
}

.popup-message.high::before,
.popup-message.red::before {
    background: #e5484d;
}

.popup-message.medium::before,
.popup-message.orange::before {
    background: #f2994a;
}

.popup-message.low::before,
.popup-message.green::before {
    background: #2f9e75;
}

.popup-message.past::before,
.popup-message.grey::before {
    background: #8a98a8;
}

.popup-topline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 9px;
}

.popup-pill {
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 9px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.66);
    color: currentColor;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
    box-shadow: inset 0 0 0 1px rgba(54, 76, 99, 0.08);
}

.popup-countdown {
    color: currentColor;
    font-size: 0.78rem;
    font-weight: 800;
    white-space: nowrap;
}

.popup-content {
    min-width: 0;
}

.customer-details h4 {
    margin: 0 0 7px;
    color: #24384f;
    font-size: 1rem;
    font-weight: 850;
    line-height: 1.15;
    letter-spacing: 0;
    overflow-wrap: anywhere;
}

.customer-details p,
.time-info p {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    margin: 5px 0;
    color: #3f5064;
    font-size: 0.82rem;
    line-height: 1.3;
    overflow-wrap: anywhere;
}

.customer-details strong,
.time-info strong {
    flex: 0 0 auto;
    color: #697789;
    font-size: 0.7rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0;
}

.time-info {
    margin-top: 9px;
    padding-top: 8px;
    border-top: 1px solid rgba(54, 76, 99, 0.12);
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid rgba(54, 76, 99, 0.1);
    background: rgba(255, 255, 255, 0.72);
    color: #52657a;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.close-button:hover {
    background: #ffffff;
    color: #24384f;
    transform: rotate(90deg);
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .popup-container {
        top: 10px;
        right: 8px;
        left: 8px;
        width: auto;
    }

    .popup-message {
        padding: 12px 40px 12px 13px;
    }

    .customer-details p,
    .time-info p {
        font-size: 0.78rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/Popup/Popup.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,8CAA8C;IAC9C,4BAA4B;IAC5B,eAAe;IACf,iCAAiC;IACjC,6EAA6E;IAC7E,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,4CAA4C;IAC5C,8CAA8C;AAClD;;AAEA;;IAEI,qBAAqB;IACrB,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,qCAAqC;IACrC,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4EAA4E;AAChF;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,SAAS;QACT,UAAU;QACV,SAAS;QACT,WAAW;IACf;;IAEA;QACI,4BAA4B;IAChC;;IAEA;;QAEI,kBAAkB;IACtB;AACJ","sourcesContent":["/* src/components/routes/Popup/Popup.css */\n\n.popup-overlay {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    max-height: calc(100vh - 40px);\n    overflow-y: auto;\n}\n\n.popup-container {\n    position: fixed;\n    top: 92px;\n    right: 18px;\n    z-index: 1200;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: min(360px, calc(100vw - 28px));\n    max-height: 75vh;\n    overflow-y: auto;\n    padding: 2px;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(54, 76, 99, 0.35) transparent;\n}\n\n.popup-message {\n    position: relative;\n    isolation: isolate;\n    overflow: hidden;\n    border: 1px solid rgba(54, 76, 99, 0.12);\n    border-radius: 8px;\n    background: #ffffff;\n    box-shadow: 0 18px 38px rgba(31, 46, 64, 0.18);\n    padding: 13px 42px 13px 14px;\n    cursor: pointer;\n    animation: slideIn 0.22s ease-out;\n    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n    text-align: left;\n    font-family: inherit;\n}\n\n.popup-message:hover {\n    transform: translateY(-2px) translateX(-2px);\n    box-shadow: 0 22px 44px rgba(31, 46, 64, 0.22);\n}\n\n.popup-message.high,\n.popup-message.red {\n    border-color: #ffb1b1;\n    background: linear-gradient(135deg, #fffafa 0%, #ffe7e7 100%);\n    color: #6d2020;\n}\n\n.popup-message.medium,\n.popup-message.orange {\n    border-color: #ffd49b;\n    background: linear-gradient(135deg, #fffaf0 0%, #ffefd7 100%);\n    color: #70430f;\n}\n\n.popup-message.low,\n.popup-message.green {\n    border-color: #afe0bf;\n    background: linear-gradient(135deg, #f7fff9 0%, #e3f8ea 100%);\n    color: #1f5b3e;\n}\n\n.popup-message.past,\n.popup-message.grey {\n    border-color: #d4dbe3;\n    background: linear-gradient(135deg, #fbfcfd 0%, #edf0f3 100%);\n    color: #52657a;\n}\n\n.popup-message::before {\n    content: '';\n    position: absolute;\n    inset: 0 auto 0 0;\n    width: 5px;\n    background: #2f9e75;\n}\n\n.popup-message.high::before,\n.popup-message.red::before {\n    background: #e5484d;\n}\n\n.popup-message.medium::before,\n.popup-message.orange::before {\n    background: #f2994a;\n}\n\n.popup-message.low::before,\n.popup-message.green::before {\n    background: #2f9e75;\n}\n\n.popup-message.past::before,\n.popup-message.grey::before {\n    background: #8a98a8;\n}\n\n.popup-topline {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 9px;\n}\n\n.popup-pill {\n    display: inline-flex;\n    align-items: center;\n    height: 22px;\n    padding: 0 9px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.66);\n    color: currentColor;\n    font-size: 0.68rem;\n    font-weight: 800;\n    letter-spacing: 0;\n    text-transform: uppercase;\n    box-shadow: inset 0 0 0 1px rgba(54, 76, 99, 0.08);\n}\n\n.popup-countdown {\n    color: currentColor;\n    font-size: 0.78rem;\n    font-weight: 800;\n    white-space: nowrap;\n}\n\n.popup-content {\n    min-width: 0;\n}\n\n.customer-details h4 {\n    margin: 0 0 7px;\n    color: #24384f;\n    font-size: 1rem;\n    font-weight: 850;\n    line-height: 1.15;\n    letter-spacing: 0;\n    overflow-wrap: anywhere;\n}\n\n.customer-details p,\n.time-info p {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 12px;\n    margin: 5px 0;\n    color: #3f5064;\n    font-size: 0.82rem;\n    line-height: 1.3;\n    overflow-wrap: anywhere;\n}\n\n.customer-details strong,\n.time-info strong {\n    flex: 0 0 auto;\n    color: #697789;\n    font-size: 0.7rem;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0;\n}\n\n.time-info {\n    margin-top: 9px;\n    padding-top: 8px;\n    border-top: 1px solid rgba(54, 76, 99, 0.12);\n}\n\n.close-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    border: 1px solid rgba(54, 76, 99, 0.1);\n    background: rgba(255, 255, 255, 0.72);\n    color: #52657a;\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;\n}\n\n.close-button:hover {\n    background: #ffffff;\n    color: #24384f;\n    transform: rotate(90deg);\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n    .popup-container {\n        top: 10px;\n        right: 8px;\n        left: 8px;\n        width: auto;\n    }\n\n    .popup-message {\n        padding: 12px 40px 12px 13px;\n    }\n\n    .customer-details p,\n    .time-info p {\n        font-size: 0.78rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
